import React, { useContext } from 'react';
import { Routes, Route, Navigate, useSearchParams } from 'react-router-dom';
import PolicyDashboard from './PolicyDashboard';
import TrainingDashboard from './TrainingDashboard';
import LexipolReportDashboard from './LexipolReportDashboard';
import RiskPoolDashboard from './RiskPoolDashboard';
import RiskPoolOrganizationDetail from './RiskPoolDashboard/RiskPoolOrganizations/Detail';
import FeaturesManager from 'utils/features/FeaturesManager';
import { DashboardProvider, useDashboard } from './context';
import { AppContext } from '../../context';

FeaturesManager.registerFeature({
  id: 'risk_pool',
  name: 'Risk Pool Overview',
  description: 'Enable Risk Pool Overview Work in Progress',
  enabled: false,
});

function DashboardContent() {
  const { tabs, availableTabValues } = useDashboard();
  const [searchParams] = useSearchParams();
  const { hasPermission, currentOrganizationId } = useContext(AppContext);

  // Check if user has riskPoolDashboard permission and redirect if they do
  const hasRiskPoolDashboardPermission = hasPermission('riskPoolDashboard', currentOrganizationId || '');
  if (hasRiskPoolDashboardPermission) {
    return (
      <Navigate
        to='risk_pool'
        replace
      />
    );
  }

  // Determine current tab - use first available tab if current tab is not available
  const currentTabParam = searchParams.get('tab');
  const currentTab =
    currentTabParam && availableTabValues.includes(currentTabParam)
      ? currentTabParam
      : availableTabValues[0] || 'policy';

  if (currentTab === 'lexipol-reports') {
    return <LexipolReportDashboard />;
  }

  if (currentTab === 'training') {
    return <TrainingDashboard />;
  }

  return <PolicyDashboard />;
}

export default function Dashboard() {
  return (
    <DashboardProvider>
      <Routes>
        <Route
          path=''
          element={<DashboardContent />}
        />
        <Route
          path='risk_pool/*'
          element={<RiskPoolDashboard />}
        />
        <Route
          path='*'
          element={
            <Navigate
              to=''
              replace
            />
          }
        />
      </Routes>
    </DashboardProvider>
  );
}
